import { listarConquistasQuery } from '../../interfaces/conquista'
import BASEURLGESTTOR, { BASEURLGESTTORFORMDATA } from '../api/gesttor'

export function novaConquista(payload: FormData) {
    return BASEURLGESTTORFORMDATA.post('/conquista', payload)
}

export function listarConquistas({ titulo, situacao }: listarConquistasQuery) {
    return BASEURLGESTTOR.get(`/conquista?titulo=${titulo || ""}&situacao=${situacao}`)
}

export function atualizarConquista(id: string, payload: FormData) {
    return BASEURLGESTTORFORMDATA.patch(`/conquista/${id}`, payload)
}